var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgTeva = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_TEVA",
    x: "0px",
    y: "0px",
    width: "135.618px",
    height: "47.517px",
    viewBox: "0 0 135.618 47.517",
    enableBackground: "new 0 0 135.618 47.517",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path148",
    fill: "#C2C2C5",
    d: "M126.163,11.008v2.007 c-2.906-2.341-6.512-3.575-10.444-3.575c-9.952,0-17.749,8.378-17.749,19.075c0,4.775,1.643,9.326,4.623,12.815 c3.295,3.873,8.395,6.187,13.645,6.187c3.766,0,7.102-1.202,9.926-3.572v2.003c0,0.451,0.364,0.819,0.811,0.819h7.835 c0.448,0,0.81-0.368,0.81-0.819V11.008c0-0.452-0.361-0.817-0.81-0.817h-7.835C126.527,10.19,126.163,10.556,126.163,11.008 M126.89,28.515c0,4.959-3.77,9.852-9.547,9.852c-5.535,0-9.547-4.258-9.547-9.852c0-6.204,4.579-9.888,9.43-9.888 C123.247,18.627,126.89,23.556,126.89,28.515"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "path152",
    fill: "#C2C2C5",
    d: "M22.396,38.646c-2.197,0-3.77-0.681-4.826-2.007 c-0.795-0.996-1.166-2.328-1.166-4.518V18.628H26.53c0.428,0,0.773-0.351,0.773-0.783v-6.934c0-0.431-0.346-0.781-0.773-0.781 H16.403V0.819C16.403,0.366,16.04,0,15.594,0H7.387c-0.447,0-0.81,0.366-0.81,0.819v9.311H0.81C0.362,10.13,0,10.497,0,10.949v6.859 c0,0.452,0.362,0.819,0.81,0.819h5.768v12.604c0,5.149,0.803,8.419,2.689,10.936c2.566,3.459,6.9,5.289,12.535,5.289 c4.343,0,7.117-1.038,8.616-2.227c0.431-0.344,0.519-1.115,0.264-1.481c-0.208-0.296-3.556-5.656-3.556-5.656 c-0.304-0.495-0.945-0.609-1.486-0.311C24.909,38.185,23.513,38.646,22.396,38.646"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "path156",
    fill: "#C2C2C5",
    d: "M46.304,9.38c-5.045,0-9.601,2.032-12.828,5.724 c-3.077,3.52-4.771,8.262-4.771,13.353c0,11.188,7.787,19.001,18.936,19.001c4.903,0,9.729-1.802,13.131-4.809 c0.152-0.136,0.331-0.309,0.516-0.496c0.286-0.288,0.32-0.746,0.076-1.072c-0.878-1.169-2.9-3.863-3.889-5.179 c-0.291-0.388-0.851-0.436-1.198-0.1c-0.224,0.215-0.491,0.459-0.772,0.688c-1.609,1.317-4.213,2.904-7.641,2.904 c-5.123,0-9.064-3.468-9.617-8.447h23.904c0.592,0,1.092-0.449,1.15-1.045c0.047-0.466,0.085-1.077,0.085-1.821 c0-5.01-1.7-9.686-4.79-13.164C55.427,11.346,51.062,9.38,46.304,9.38 M46.304,17.441c3.076,0,6.614,2.365,7.023,6.194H38.692 C39.155,20.638,42.166,17.441,46.304,17.441"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "path160",
    fill: "#B7B7B7",
    d: "M81.245,38.088l0.016-5.229 c0.004-2.131,0.445-4.512,1.264-6.938c0.929-2.765,2.266-5.112,3.744-6.822l2.259-2.925v12.223L81.245,38.088z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "path164",
    fill: "#CCCCCC",
    d: "M88.527,16.173l4.796-6.213 c0.387-0.51,1.022-0.688,1.594-0.464c0.574,0.227,0.955,0.804,0.949,1.463l-0.035,7.722l-7.304,9.716V16.173z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "path168",
    fill: "#B5B5B5",
    d: "M95.83,18.681l-0.022,4.436 c0.077,2.276-0.301,4.897-1.196,7.556c-0.819,2.428-1.888,4.562-3.153,6.197l-2.932,3.813V28.396L95.83,18.681z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "path172",
    fill: "#C2C2C5",
    d: "M88.527,28.396v12.286l-4.763,6.195 c-0.387,0.509-1.023,0.686-1.596,0.462c-0.572-0.226-0.955-0.804-0.949-1.462l0.025-7.79L88.527,28.396z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "path176",
    fill: "#B7B7B7",
    d: "M80.212,38.088l-0.016-5.229 c-0.005-2.131-0.445-4.512-1.264-6.938c-0.93-2.765-2.268-5.112-3.746-6.822l-2.258-2.925v12.223L80.212,38.088z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "path180",
    fill: "#CCCCCC",
    d: "M72.928,16.173L68.133,9.96 c-0.388-0.51-1.022-0.688-1.596-0.464c-0.571,0.227-0.954,0.804-0.948,1.463l0.037,7.722l7.302,9.716V16.173z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "path184",
    fill: "#B5B5B5",
    d: "M65.626,18.681l0.021,4.436 c-0.076,2.276,0.301,4.897,1.197,7.556c0.818,2.428,1.887,4.562,3.154,6.197l2.928,3.813V28.396L65.626,18.681z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "path188",
    fill: "#C2C2C5",
    d: "M72.928,28.396v12.286l4.763,6.195 c0.387,0.509,1.024,0.686,1.598,0.462c0.57-0.226,0.952-0.804,0.947-1.462l-0.023-7.79L72.928,28.396z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgTeva, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/teva.22fc4264.svg";
export { ForwardRef as ReactComponent };